export default __webpack_public_path__ + "static/media/three.a2f0e45a.jpeg";